<template>
  <form @submit.prevent="executeRecaptcha" class="tw-space-y-6">
    <div class="tw-space-y-4">
      <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-space-x-4">
        <FormInput
          v-model="form.mentee.firstName"
          type="text"
          autofocus
          :is-error="Boolean(form.errors.first_name)"
          :errors="form.errors.first_name"
          @input="form.clearErrors('first_name')"
        >
          <template #label>First name</template>
        </FormInput>
        <FormInput
          v-model="form.mentee.lastName"
          type="text"
          :is-error="Boolean(form.errors.last_name)"
          :errors="form.errors.last_name"
          @input="form.clearErrors('last_name')"
        >
          <template #label>Last name</template>
        </FormInput>
      </div>
      <FormInput
        v-model="form.mentee.email"
        type="email"
        autocomplete="email"
        :is-error="Boolean(form.errors.email)"
        :errors="form.errors.email"
        @input="form.clearErrors('email')"
      >
        <template #label>Email</template>
      </FormInput>
      <FormInput
        v-model="form.mentee.password"
        type="password"
        autocomplete="new-password"
        :is-error="Boolean(form.errors.password)"
        :errors="form.errors.password"
        @input="form.clearErrors('password')"
      >
        <template #label>Password</template>
      </FormInput>
      <FormCheckbox
        v-model="form.mentee.hp"
        autocomplete="off"
        tabindex="-1"
        class="tw-absolute tw-hidden tw-h-px tw-w-px tw-overflow-hidden tw-opacity-0"
      >
        Huemans should NOT clik this.
      </FormCheckbox>
    </div>
    <BaseButton
      type="submit"
      color="purple"
      is-block
      :is-rounded="false"
      size="large"
      class="tw-rounded-lg tw-shadow-md"
      :is-disabled="form.processing"
    >
      {{ form.processing ? 'Creating account...' : 'Create account' }}
      <LoadingCircle v-if="form.processing" size="16" class="tw-ml-2" />
    </BaseButton>
    <div ref="recaptchaRef" />
  </form>
</template>

<script setup>
import FormInput from '@/shared/components/forms/FormInput.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import LoadingCircle from '@/shared/components/LoadingCircle.vue'
import snakeCaseKeys from 'snakecase-keys'
import FormCheckbox from '@/shared/components/forms/FormCheckbox.vue'
import { useForm } from '@inertiajs/vue3'
import { useChallengeV2 } from 'vue-recaptcha/head'

const {
  root: recaptchaRef,
  execute: executeRecaptcha,
  onVerify: onRecaptchaVerify,
  reset: resetRecaptcha,
} = useChallengeV2({
  options: {
    size: 'invisible',
  },
})

const form = useForm({
  mentee: {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    hp: false,
  },
})

onRecaptchaVerify((token) => {
  form
    .transform((data) => ({
      ...snakeCaseKeys(data),
      'g-recaptcha-response': token,
    }))
    .post('/mentees', {
      onError: () => {
        // Each time if there is an error, we have to reset recaptcha to send another request
        resetRecaptcha()
      },
    })
})
</script>
